// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BlockInnerTextButton_wrap__dwCem","wrap-contents":"BlockInnerTextButton_wrap-contents__wQ19d","wrap-button":"BlockInnerTextButton_wrap-button__lcGhn"};